import React from 'react';
import { LoadingSpinner } from '@uhg-abyss/web/ui/LoadingSpinner';
import { styled } from '@uhg-abyss/web/tools/styled';

const Wrapper = styled('div', {
  position: 'fixed',
  inset: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 9999,
  pointerEvents: 'none',
});

const BlockingWrapper = styled(Wrapper, {
  pointerEvents: 'auto',
  backgroundColor: 'rgba(248, 252, 255, 0.45)',
  backdropFilter: 'blur(2px)',
  WebkitBackdropFilter: 'blur(2px)',
});

interface PageSpinnerProps {
  label?: string;
  blocking?: boolean;
}

export const PageSpinner = ({ label = 'Loading', blocking = false }: PageSpinnerProps) => {
  const Container = blocking ? BlockingWrapper : Wrapper;
  return (
    <Container role="status" aria-label={label}>
      <LoadingSpinner isLoading ariaLoadingLabel={label} size="lg" />
    </Container>
  );
};
